import React from 'react';
import '../styling/home.css';
import { Link, Navigate } from 'react-router-dom';

export default function Home() {
    return (
        <>
            {localStorage.getItem('answer_completed') ? <Navigate to='/result' /> :
                <div className='home'>
                    <div className="whiteback">
                        <div className='headdiv'>
                            <h2 className='homehead'>Test For Best Friends-BFF Quiz</h2>
                        </div>
                        <div className='instdiv'>
                            <span className='inst'>On GuessYourBond you can create a fun and quick quiz to test your friends. The quiz contain 9 questions. You can edit both question and options while creating.Take a moment and make your friendship quiz now!</span>
                        </div>
                        <div className='stbtndiv'>
                            <button className='stbtn'><Link to='/start' className='btnlink' >Start</Link></button>
                        </div>
                    </div>
                    <div className="homemat">
                        <div className="mat">
                            <h2 className="mathead">who know me best?</h2>
                            <div className='matcon'>If you want to get the answer to this question, make a fun and quick picture quiz for your friends!</div>
                        </div>
                        <div className="mat">
                            <h2 className="mathead">Quiz About Me</h2>
                            <div className='matcon'>With QuizYourMate it's easy! Just go through our set of picture questions. Then select and answer 9 of them. Your quiz is ready!</div>
                        </div>
                        <div className="mat">
                            <h2 className="mathead">Friendship Trivia</h2>
                            <div className='matcon'>When you answer the 9 questions, you'll get a link to your quiz. Share it with your friends on Whatsaap, Messenger, or via email. You can check their results with the same link.</div>
                        </div>
                        <div className="mat">
                            <h2 className="mathead">Have fun with your friends!</h2>
                            <div className='matcon'>Don't treat this test too seriously! It was made for entertainment and can be used as a good way to get to know each other better.</div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}
